import { render, staticRenderFns } from "./CRMIntegration.vue?vue&type=template&id=dc80b988"
import script from "./CRMIntegration.vue?vue&type=script&lang=js"
export * from "./CRMIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports